// extracted by mini-css-extract-plugin
module.exports = {"root":"page-index-list_root__DTvOl","list":"page-index-list_list__zUcGo"};